module.exports = new __parcel__URL__("card_hawg.c4d4f8df.jpg").toString();